export default __webpack_public_path__ + "static/MindfulMemorials_LogoSlate-25a8b1a35e2dd2f9f9650b0d6dc69135.svg";